<template>
	<div>
		<!-- Select template -->
		<div
			class="xs-12 flex xs-middle bc7 bb1 pb3 pt3"
			v-for="item in computedTemplates"
		>
			<div class="xs-8 lh125">{{ item.name }}</div>
			<div class="xs-4 flex xs-right">
				<j-button
					size="xsmall"
					type="bordered"
					:isDisabled="isLoading"
					@click="onDownload(item)"
				>
					Download
				</j-button>
			</div>
		</div>

		<div class="mt4">
			<j-spinner v-if="isLoading" :delay="50" />
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JSpinner from "@/components/JSpinner"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JButton, JSpinner },

	props: {
		policyId: {
			type: String
		},

		contractCurrency: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false,

			// Templates
			templates: [],
			selectedTemplate: null
		}
	},

	computed: {
		computedTemplates() {
			// HACK:
			// We are using ID to reference templates to display
			const templateIdsToDisplay = [
				"60921588-302f-4ad0-9a41-fd4a716411eb",
				"cb69df71-12b9-4d14-ad88-022451096019",
				"a6def365-fb26-4456-b91c-67cf2d714e49"
			]

			return this.templates.filter(item =>
				templateIdsToDisplay.includes(item.id)
			)
		}
	},

	methods: {
		onDownload(template) {
			this.selectedTemplate = template
			this.downloadPdf()
		},

		async fetchTemplates(value = "") {
			const query = gql`
				query fetchTemplates($where: templateWhereInput!, $sort: sortInput) {
					templates(where: $where, sort: $sort) {
						totalCount
						list {
							id
							name
							createdAt
							lastModifiedAt
							__typename
						}
					}
				}
			`

			let variables = {
				where: {},
				sort: { fieldName: "createdAt", type: "desc" }
			}

			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false

			this.templates =
				res?.data?.templates?.list
					?.filter(
						item =>
							item?.__typename === "pdfDrawingTemplate" ||
							item?.__typename === "wkhtmltopdfTemplate"
					)
					?.map(item => ({
						name: item.name,
						id: item.id,
						typeName: item.__typename
					})) || []
		},

		async downloadPdf() {
			// Decide if it is PDF file or HTML PDF
			const templateType = this.selectedTemplate?.typeName
			let apiKey = "renderPdfDrawingTemplate"
			if (templateType === "wkhtmltopdfTemplate")
				apiKey = "renderWkhtmltopdfTemplate"

			// Query
			const query = `
				query ${apiKey}($templateId: String!, $input: templateRenderParametersInput){
					${apiKey}(templateId: $templateId input: $input) {
						errors
						status
						value
					}
				}
			`

			// Variables
			const variables = {
				templateId: this.selectedTemplate?.id,
				input: { name: "data" }
			}

			const currencyOptions = this.contractCurrency
				? { currencyCodes: [this.contractCurrency] }
				: { currencyCodes: [] }

			variables.input.variablesJsonString = JSON.stringify({
				where: { id: this.policyId },
				currencyOptions
			})

			console.error({ variables })

			// Call
			this.isLoading = true
			const res = await api({ query, variables })
			this.isLoading = false

			// Errors
			if (res?.data?.[apiKey]?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.[apiKey]?.errors?.[0] || [this.$t("errors.general")]
				)
				return
			}

			// Download file
			let bytes = new Uint8Array(res.data?.[apiKey]?.value) // pass your byte response to this constructor
			let blob = new Blob([bytes], { type: "application/pdf" }) // change resultByte to bytes
			let link = document.createElement("a")
			link.href = window.URL.createObjectURL(blob)
			link.download = `${this.selectedTemplate?.name}.pdf`
			link.click()
		}
	},

	mounted() {
		this.fetchTemplates()
	}
}
</script>
